import { render, staticRenderFns } from "./Aplicaciones.vue?vue&type=template&id=1475b141&scoped=true"
import script from "./Aplicaciones.vue?vue&type=script&lang=js"
export * from "./Aplicaciones.vue?vue&type=script&lang=js"
import style0 from "./Aplicaciones.vue?vue&type=style&index=0&id=1475b141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475b141",
  null
  
)

export default component.exports